export default {"src":"/_next/static/media/low-cost-campus-hiring.6a8ea661.svg","height":151,"width":151,"blurWidth":0,"blurHeight":0};